module.exports = __webpack_public_path__ + "bb5.no2.1d635d8f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/bb5.no2.jpg
// module id = C646
// module chunks = 0